import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileUploadModule } from 'ng2-file-upload';

import { MenuModule } from 'primeng/menu';
import { APP_BASE_HREF } from '@angular/common';

import { NgSelectModule } from '@ng-select/ng-select';
import {SelectCountryComponent} from './select-country/select-country.component';
import {GenerateXmlService} from './services/generate-xml.service';
import {GenerateExcelService} from './services/generate-excel.service';
@NgModule({
  declarations: [AppComponent,SelectCountryComponent
  ],
  entryComponents:[SelectCountryComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxPaginationModule,
    FileUploadModule,
    MenuModule,
    NgSelectModule,
    SimpleNotificationsModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/', },GenerateExcelService, GenerateXmlService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts